import { render, staticRenderFns } from "./EditCobranca.vue?vue&type=template&id=d045eb7e&"
import script from "./EditCobranca.vue?vue&type=script&lang=js&"
export * from "./EditCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports